<style scoped>
.wechat_two_body {
  margin: 40px 30px;
}
.wechat_two_body .verify_text {
  font-size: 30px;
  font-weight: 500;
  color: #1a1a1a;
}
.wechat_two_body .verify_body_text {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.wechat_two_body .verify-check-code_tip {
  font-size: 14px;
  margin-top: 10px;
  color: #999;
}
::v-deep .wechat_two_body .verify-check-code_tip .el-link.el-link--default {
  font-size: 14px;
}
.wechat_content{
  text-align: center;
  display: grid;
  justify-content: center;
}
.wechat_content .qr-code{
  display: flex;
  justify-content: center;
  padding: 10px;
  border: 2px solid #f0f0f0;
  border-radius: 5px;
}
</style>

<template>
  <el-dialog
      width="420px"
      height="453px"
      custom-class="dialog-binding-wechat"
      :visible.sync="wechatVisible"
      :close-on-click-modal="false"
  >
    <div class="wechat_two_body">
      <span class="verify_text"></span>
      <div class="wechat_content">
        <p class="verify_body_text">微信扫码绑定</p>
        <div class="qr-code">
          <div id="wechatLoginCanvas" ref="wechatLoginCanvasRef"></div>
        </div>
        <p class="verify-check-code_tip">请用微信扫描二维码绑定</p>
      </div>
    </div>
  </el-dialog>
</template>


<script>
import QRCode from "qrcode";
import {WechatOauthApi} from "@/api/server/wechatOauth";

export default {
  components: {},
  data() {
    return {
      wechatVisible: false,
      refreshing: false,
      scanTimer: null,
      state: null
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    show(){
      this.wechatVisible = true;
      this.$nextTick(() => {
        this.initQrcode();
      })
    },
    initQrcode(){
      this.refreshing = true;
      //获取二维码链接
      this.$refs.wechatLoginCanvasRef.innerHTML = '';
      WechatOauthApi.render({type: 'binding'}).then(res => {
        const {code,data} = res;
        if(code == 200){
          const {state,url} = data;
          this.state = state;
          QRCode.toCanvas(url, {
            width: 150,
            height: 150,
            margin: 0,
            scale: 10, // 二维码的每个模块占用的像素数，默认为4
            errorCorrectionLevel: "L",
            color: { // 二维码的颜色配置
              dark: '#000000', // 深色模块的颜色
              light: '#ffffff' // 浅色模块的颜色（背景色）
            }
          },(error, canvas) => {
            if (error) {
              console.error(error);
              return;
            }
            // 在canvas的父元素中插入canvas元素
            this.$nextTick(() => {
              this.$refs.wechatLoginCanvasRef.appendChild(canvas);
            });
          });

          this.checkScanStatus();
        }
      }).finally(() => {
        this.refreshing = false;
      })
    },
    async checkScanStatus() {
      if(this.scanTimer){
        clearInterval(this.scanTimer);
      }
      this.scanTimer = setInterval(async () => {
        const params = {state: this.state}
        const {code,data} = await WechatOauthApi.check(params);
        if(code == 200){
          if(this.scanTimer){
            clearInterval(this.scanTimer);
          }
          setTimeout( () => {
            this.wechatVisible = false;
            const result = {openid: data?.rawUserInfo?.openid, unionid: data?.rawUserInfo?.unionid, state: this.state};
            this.$emit('success',result);
          },1500)
        }
      },2000)
    },
  },
  beforeDestroy() {
    if (this.scanTimer) {
      clearInterval(this.scanTimer);
    }
  }
};
</script>